/**
 * Заглушка для `renderCell` при `forStub: true`.
 *
 * @kind helper
 */
export const renderEmptyCell = () => null;
